/*global $*/
import React from "react";

import newsticker from "../common/jQueryNewsTicker.js";
//import gnpfooter from "./footer.css";

class PortalFooter extends React.Component {
	componentDidMount = () => {
		function movePusePlayBtn(){
			if (window.matchMedia("(max-width: 992px)").matches) {
				//Mobile..
				$(".jnt-prev").prependTo(".ticker-controls");
		
			}else if(window.matchMedia("(min-width: 993px)").matches){
				//Desktop..
				$(".jnt-play-pause").prependTo(".ticker-controls");
			}
		
		}//function movePusePlayBtn() ends..
		
		/*$( document ).ready(function() {
			console.log("ticker init");
			$(function () {
				$("#js-news").ticker({
					speed:        0.10,
					ajaxFeed:     false,
					feedUrl:      false,
					feedType:     "xml",
					htmlFeed:     true,
					debugMode:    true,
					controls:     true,
					titleText:    "NOTICIAS GNP | ",
					displayType:  "reveal",
					direction:    "ltr",
					pauseOnItems: 2000,
					fadeInSpeed:  600,
					fadeOutSpeed: 300
				});
			});
			movePusePlayBtn();
		});*/
		
		$( window ).resize(function() {
			movePusePlayBtn();
		});
	}
	
	render() {
		return (
			<footer id="main-footer" className="container-fluid footer">
				<div className="container" >
					<div className="row noMargin">
						<div className="col m12 s12">
							<ul id="js-news" className="js-hidden">
						        <li className="news-item"><a href="/">Tipo de cambio al día $17.7755 pesos (Banco de México)</a></li>
						        <li className="news-item"><a href="/">GNP Seguros inaugura oficinas.</a></li>
						        <li className="news-item"><a href="/">Inicia GNP Seguros nueva etapa en Corporativo Andares.</a></li>
						        <li className="news-item"><a href="/">GNP reforestará más de 20 hectáreas de bosque en pro del carbono neutral.</a></li>
						        <li className="news-item"><a href="/">Las 50 mejores campañas de publicidad.</a></li>
						        <li className="news-item"><a href="/">Cuatro acciones básicas pueden ayudar a eliminar el hábito del trabaquismo: GNP.</a></li>
						        <li className="news-item"><a href="/">Ataque cibernético impulsará seguros: GNP</a></li>
						        <li className="news-item"><a href="/">Entrevista con Mario Vela de GNP sobre seguros</a></li>
						    </ul>
						</div>
					</div>
					<div className="row">
						<div className="col l12 m12 s12 noPadding-md-down" >
							<ul className="sections" >
								<li className="col xl2 l2 m4 s4" >
									<a href="https://www.gnp.com.mx/wps/portal/portalesgnp/post-venta/conocenos">
										<i className="sp sp-two-people"></i>
										<p>Conócenos <br/><br/></p>
									</a>
								</li>
								<li className="col xl2 l2 m4 s4" >
									<a href="https://www.gnp.com.mx/wps/portal/portalesgnp/post-venta/contacto">
										<i className="sp sp-info"></i>
										<p>Asistencia y<br />contacto</p>
									</a>
								</li>
								<li className="col xl2 l2 m4 s4" >
									<a href="https://busqueda-agentes-dot-gnp-portalcorporativo-pro.appspot.com/">
										<i className="sp sp-agente"></i>
										<p>Busca <br/>un agente</p>
									</a>
								</li>
								<li className="col xl2 l2 m4 s4" >
									<a href="https://www.gnp.com.mx/wps/portal/portalesgnp/login-intermediarios-corporativo">
										<i className="sp sp-person"></i>
										<p>Acceso a<br />intermediarios</p>
									</a>
								</li>
								<li className="col xl2 l2 m4 s4" >
									<a href="https://www.gnp.com.mx/wps/portal/portalesgnp/post-venta/unete-a-gnp">
										<i className="sp sp-cv"></i>
										<p>Únete a<br />nosotros</p>
									</a>
								</li>
								<li className="col xl2 l2 m4 s4" >
									<a href="https://www.gnp.com.mx/wps/portal/portalesgnp/post-venta/responsabilidad-social">
										<i className="sp sp-hands"></i>
										<p>Responsabilidad<br />social</p>
									</a>
								</li>
							</ul>
						</div>
					</div>
					<div className="row">
						<div className="col m12 s12">
							<ul className="menu footerCarousel">
								<li className="footerCarousel-links">
									<a href="http://myapps.microsoft.com/">Colaboradores</a>
								</li>
								{
								/*
								<li className="footerCarousel-links">
									<a href="https://www.gnp.com.mx/wps/portal/portalesgnp/post-venta/cuida-salud/">GNP Cuida tu Salud</a>
								</li>
								*/
								}
								<li className="footerCarousel-links">
									<a href="https://www.gnp.com.mx/wps/portal/portalesgnp/post-venta/conocenos/masinfo/informacion-financiera/">Información Financiera</a>
								</li>
								<li className="footerCarousel-links">
									<a href="https://www.gnp.com.mx/wps/portal/portalesgnp/post-venta/conocenos/masinfo/buro-entidades-financieras">Buró de Entidades Financieras</a>
								</li>
								<li className="footerCarousel-links">
									<a href="https://www.gnp.com.mx/wps/portal/portalesgnp/anexos/terminos-legales/medios-electronicos">Uso de Medios Electrónicos</a>
								</li>
								<li className="footerCarousel-links">
									<a href="https://www.gnp.com.mx/wps/portal/portalesgnp/anexos/aviso-privacidad">Aviso de privacidad</a>
								</li>
								<li className="footerCarousel-links">
									<a href="https://www.gnp.com.mx/wps/portal/portalesgnp/anexos/preceptos-legales">Preceptos Legales</a>
								</li>
								<li className="footerCarousel-links">
									<a href="https://www.gnp.com.mx/wps/portal/portalesgnp/anexos/etica-integridad">Ética e Integridad</a>
								</li>
							</ul>
						</div>
					</div>
					<div className="row icon-links">
						<div className="col m6 s12">
							<img src="https://storage.googleapis.com/static-portalcorporativo-uat.gnp.com.mx/images/site/empresa-responsable.png" alt="empresa-100-por-ciento-responsable" />
							<img src="https://storage.googleapis.com/static-portalcorporativo-uat.gnp.com.mx/images/site/empresa-familiarmente.png" alt="empresa-familiarmente" />
							<img src="https://storage.googleapis.com/static-portalcorporativo-uat.gnp.com.mx/images/site/norma-mexicana.png" alt="norma-mexicana" />
							<img src="https://storage.googleapis.com/static-portalcorporativo-uat.gnp.com.mx/images/site/empresa-incluyente.png" alt="empresa-incluyente" />
							<p style={{ fontSize: 8 }}>Copyright© 2015 Grupo Nacional Provincial S.A.B.</p>
						</div>
						<div className="col m6 s12">
							<a href="http://es-es.facebook.com/pages/GNP-SEGUROS-OFICIAL/387796290649">
								<i className="icon-fb"></i>
							</a>
							<a href="http://twitter.com/#!/gnpseguros">
								<i className="icon-twitter"></i>
							</a>
							<a href="http://www.youtube.com/user/GNPviviresincreible">
								<i className="icon-youtube"></i>
							</a>
							<a href="https://instagram.com/gnpseguros/">
								<i className="icon-instagram"></i>
							</a>
							<a href="https://plus.google.com/109326069322011020380/">
								<i className="icon-googleplus"></i>
							</a>
							<a href="http://luliygabo.com/">
								<i className="icon-luligabo"></i>
							</a>
						</div>
					</div>
				</div>
			</footer>
		);
	}
}

export default PortalFooter;



// WEBPACK FOOTER //
// ./src/footer/portalFooter.cmpt.js